<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 17:05:31
 * @LastEditTime: 2020-06-21 17:43:30
 * @Description: 题目列表
 -->
<template>
  <div class="questions">
    <div v-for="(question, index) in answerDetail" :key="question.id" class="question">
      <!-- type 为 Single -->
      <template v-if="question.questionType === '单选' || question.questionType === '判断'">
        <single-choice
          :status="status"
          :index="index"
          :question="question"
          @preview-media="previewMedia" />
      </template>
      <!-- type 为 Multiple -->
      <template v-else-if="question.questionType === '多选' || question.questionType === '不定项选择'">
        <multiple-choice
          :status="status"
          :index="index"
          :question="question"
          @preview-media="previewMedia" />
      </template>
      <!-- type 为 Text -->
      <template v-else-if="question.questionType === '填空'">
        <text-question
          :status="status"
          :index="index"
          :question="question"
          @preview-media="previewMedia" />
      </template>
      <!-- type 为 Short -->
      <template v-else-if="question.questionType === '简答'">
        <short-question
          :index="index"
          :question="question"
          :maker="maker"
          :old-total-score="oldTotalScore"
          @preview-media="previewMedia"
          @set-question-score="setQuestionScoreHandler"
          @repull-info="repullInfoHandler" />
      </template>
    </div>

    <preview-media-modal
      :show="previewMediaData.modalShow"
      :media-path="previewMediaData.mediaPath"
      :media-type="previewMediaData.mediaType"
      :video-cover="previewMediaData.videoCover"
      @close-modal="closeModalHandler" />

    <pdf-player-modal
      :show="previewPdfMediaModalShow"
      :media-type="previewMediaData.mediaType"
      :url="previewMediaData.mediaPath"
      @close-modal="previewPdfMediaModalShow = false" />
  </div>
</template>

<script>
import SingleChoice from './SingleChoice.vue';
import MultipleChoice from './MultipleChoice.vue';
import TextQuestion from './TextQuestion.vue';
import ShortQuestion from './ShortQuestion.vue';
import PreviewMediaModal from '../../online/components/PreviewMediaModal.vue';
import PdfPlayerModal from '../../online/components/PdfPlayerModal.vue';

export default {
  name: 'Questions',
  components: {
    SingleChoice,
    MultipleChoice,
    TextQuestion,
    ShortQuestion,
    PreviewMediaModal,
    PdfPlayerModal,
  },
  props: {
    status: { type: String, required: true },
    answerDetail: { type: Array, required: true },
    maker: { type: Boolean, required: true },
    oldTotalScore: { type: [Number, String], required: true },
  },
  data() {
    return {
      previewMediaData: {
        modalShow: false,
        mediaType: '',
        mediaPath: '',
        videoCover: '',
      },
      previewPdfMediaModalShow: false,
    };
  },
  methods: {
    /**
     * 设置简答题题目分数处理函数
     */
    setQuestionScoreHandler({ index, score }) {
      this.$set(this.answerDetail[index], 'score', score);
    },
    /**
     * 重新拉取考生信息处理函数
     */
    repullInfoHandler() {
      this.$emit('repull-info');
    },
    previewMedia({ mediaContentType, mediaPath, videoCover }) {
      const imageReg = /image/;
      const audioReg = /audio/;
      const videoReg = /video/;
      const pdfReg = /pdf/;

      if (imageReg.test(mediaContentType)) {
        this.previewMediaData.mediaType = 'jpg';
        this.previewMediaData.mediaPath = mediaPath;
        this.previewMediaData.modalShow = true;
        return;
      }

      if (audioReg.test(mediaContentType)) {
        this.previewMediaData.mediaType = 'mp3';
        this.previewMediaData.mediaPath = mediaPath;
        this.previewMediaData.modalShow = true;
        return;
      }

      if (videoReg.test(mediaContentType)) {
        this.previewMediaData.mediaType = 'mp4';
        this.previewMediaData.mediaPath = mediaPath;
        this.previewMediaData.videoCover = videoCover;
        this.previewMediaData.modalShow = true;
        return;
      }

      if (pdfReg.test(mediaContentType)) {
        this.previewMediaData.mediaType = 'pdf';
        this.previewMediaData.mediaPath = mediaPath;
        this.previewPdfMediaModalShow = true;
        // window.open(mediaPath, '_blank');
        // if (process.env.NODE_ENV === 'development') {
        //   window.open(`/#/tools/preview/pdf/${this.$base64.encode(mediaPath)}`, '_blank');
        // } else {
        //   window.open(`/examcentersite/#/tools/preview/pdf/${this.$base64.encode(mediaPath)}`, '_blank');
        // }
        return;
      }

      alert('未知媒体类型');
    },
    closeModalHandler() {
      this.previewMediaData.modalShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.questions {
  margin-top: 12px;
  width: 100%;

  > .question {
    margin-bottom: 12px;
    padding: 12px 18px;
    background-color: #e8ecf7;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
/deep/.ivu-btn-small{
  cursor: default;
}
</style>
